import * as React from 'react';
import { useNotify, useRecordContext, useTranslate } from 'react-admin';
import Button from '@mui/material/Button';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { StatsTooltip } from '../../components/statistics/common';

// label-propia ei käytetä täällä, mutta DatagridConfigurable lukee sen sarakevalitsinta varten.
const CustomLogAsPupilButton = (_props: { label?: string }) => {
    const record = useRecordContext();
    const translate = useTranslate();
    const notify = useNotify();
    const application = '5b846602-4428-4c2d-b12a-d2b56dd722b7';
    const ttl = 60;

    const handleClick = async e => {
        e.stopPropagation();

        const api = `${process.env.REACT_APP_INFRA_API}/aspa/create_auth_token`;
        const token = localStorage.getItem('token');

        try {
            const response = await fetch(api, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user_guid: record.id,
                    app_id: application,
                    ttl: ttl,
                }),
            });

            if (response.status >= 400) {
                throw new Error('Bad response from server');
            }

            const data = await response.json();
            const baseUrl = {
                dev: 'https://oppimateriaalit-id-dev.otava.fi/v1/oidc/pupil/login',
                next: 'https://oppimateriaalit-id-next.otava.fi/v1/oidc/pupil/login',
                beta: 'https://oppimateriaalit-id-beta.otava.fi/v1/oidc/pupil/login',
                localhost: 'http://localhost:8086/v1/oidc/pupil/login',
                default:
                    'https://oppimateriaalit-id.otava.fi/v1/oidc/pupil/login',
            };

            const env =
                Object.keys(baseUrl).find(key =>
                    new RegExp(`${key}`).test(window.location.hostname)
                ) || 'default';
            window.open(
                `${baseUrl[env]}?authtoken=${data.token}&hash=${data.hash}`,
                '_blank'
            );
        } catch (e) {
            console.error(e);
            notify(`notifications.MATERIAL_PREVIEW_ERROR`, { type: 'warning' });
        }
    };

    const now = new Date();
    const validFrom = record.public?.validfrom
        ? new Date(record.public.validfrom)
        : null;
    const validTo = record.public?.validto
        ? new Date(record.public.validto)
        : null;

    const formatDate = dateString => {
        const date = new Date(dateString);
        return date.toLocaleDateString('fi-FI', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric',
        });
    };

    const getDisabledReason = () => {
        if (record.status !== 0)
            return translate('actions.login_as.user_inactive');
        if (record.public?.profile_locked)
            return translate('actions.login_as.profile_locked');
        if (record.public?.login_not_allowed)
            return translate('actions.login_as.login_not_allowed');
        if (validFrom && now < validFrom)
            return translate('actions.login_as.access_starts_on', {
                date: formatDate(record.public.validfrom),
            });
        if (validTo && now > validTo)
            return translate('actions.login_as.access_expired_on', {
                date: formatDate(record.public.validto),
            });
        return null;
    };

    const disabledReason = getDisabledReason();
    const isDisabled = !!disabledReason;

    return (
        <StatsTooltip
            title={
                disabledReason || translate('actions.login_as.pupil_tooltip')
            }
            followCursor
            placement="top-start"
            componentsProps={{
                tooltip: {
                    sx: {
                        padding: '12px 16px',
                        fontSize: '14px',
                        lineHeight: 1.4,
                    },
                },
            }}
        >
            <span>
                <Button
                    onClick={handleClick}
                    disabled={isDisabled}
                    size="small"
                >
                    <RemoveRedEyeIcon />
                </Button>
            </span>
        </StatsTooltip>
    );
};

export default CustomLogAsPupilButton;
